module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protocol-page"
  }, _vm._l((_vm.content), function(item) {
    return _c('div', {
      attrs: {
        "id": item.key
      }
    }, [(_vm.hasContent(item)) ? _c('h3', {
      attrs: {
        "id": item.key + '-header'
      }
    }, [_vm._v("\n      " + _vm._s(item.header) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
      attrs: {
        "id": item.key + '-content'
      },
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02aa924c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Protocol.vue
// module id = 149
// module chunks = 2